module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: 'result_' + _vm.insurer.name,
    staticClass: "data resultado",
    attrs: {
      "id": 'result-' + _vm.insurer.name,
      "insurer": 'result-' + _vm.insurer.name
    }
  }, [_c('div', {
    staticClass: "row data grey-top-border with-spacing-top"
  }, [_c('span', {
    ref: "popupMessage",
    staticClass: "popup_message"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-2 small-x-padding col-seguradora-order"
  }, [(_vm.showOffer) ? _c('img', {
    staticClass: "oferta",
    attrs: {
      "src": "images/ofertas.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "insurer-badge",
    class: {
      'open-insurer': _vm.insurerAccess
    },
    attrs: {
      "data-seguradora-id": _vm.insurer.id,
      "data-insurer": _vm.insurer.name,
      "data-insurer-id": _vm.insurer.id,
      "data-insurer-badge": _vm.insurer.name,
      "data-tab-id": _vm.tabId,
      "src": (_vm.imagesPath || 'images/login-seguradoras') + '/' + _vm.insurer.name + '.png',
      "title": _vm.insurer.nome
    },
    on: {
      "click": _vm.openInsurer
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.insurer.nome_abreviado))])]), _vm._v(" "), (_vm.insurer.inativo) ? _c('div', [_c('div', {
    staticClass: "col-md-8 inactive with-spacing-top"
  }, [_c('div', {
    staticClass: "alert insurer-inactive",
    class: _vm.insurer.instabilidade ? 'alert-danger' : 'alert-info'
  }, [_vm._v(_vm._s(_vm.insurer.instabilidade ? _vm.result.msg_seguradora_fora : _vm.result.msg_seguradora_inativa) + "\n                ")])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-3 col-sm-2 col-md-1 margin-top-15 small-x-padding"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingQuotation),
      expression: "!loadingQuotation"
    }],
    staticClass: "buttons",
    class: {
      'has-error': _vm.errors.has('preco[comissao[' + _vm.insurer.name + ']]')
    }
  }, [_c('div', {
    style: ({
      width: '76px',
      margin: '0 auto',
      visibility: (_vm.commissionAccess && _vm.showCommission ? 'visible' : 'hidden')
    })
  }, [_c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insurer.commission),
      expression: "insurer.commission"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          numeric: true,
          min_value: 1,
          max_value: 100,
          required: true
        }
      }),
      expression: "{ rules: { numeric: true, min_value: 1, max_value: 100, required: true} }"
    }],
    staticClass: "form-control comission",
    attrs: {
      "type": "text",
      "id": 'preco_comissao[' + _vm.insurer.name + ']',
      "name": 'preco[comissao[' + _vm.insurer.name + ']]',
      "data-vv-as": "Comissão"
    },
    domProps: {
      "value": (_vm.insurer.commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.insurer, "commission", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon comission"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-light btn-xs btn-calculate",
    attrs: {
      "title": "Calcular",
      "disabled": _vm.disableButtonQuote
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForm($event, _vm.insurer)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "calculator"
    }
  }), _c('span', [_vm._v(" Cotar")])], 1), _vm._v(" "), (_vm.errors.has('preco[comissao[' + _vm.insurer.name + ']]')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('preco[comissao[' + _vm.insurer.name + ']]')))]) : _vm._e()])]), _vm._v(" "), (_vm.loadingQuotation) ? _c('div', {
    staticClass: "col-xs-4 col-md-4 result-actions with-spacing-top"
  }, [_c('img', {
    attrs: {
      "src": (_vm.imagesPath || 'images/status') + '/loading3.gif',
      "height": "60"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showQuotationResult) ? _c('div', {
    staticClass: "col-xs-1 col-md-1 hidden-xs hidden-sm small-x-padding col-segundos-order"
  }, [_vm._v("\n                " + _vm._s(_vm.quotationResult.time) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showQuotationResult) ? _c('div', {
    staticClass: "col-xs-3 col-md-2 text-left hidden-xs hidden-sm small-x-padding"
  }, [_c('div', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.quotationResult.product))])]) : _vm._e(), _vm._v(" "), (_vm.showQuotationResult) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-2 margin-top-15 text-center small-x-padding col-valores-order"
  }, [_c('a', {
    staticClass: "amazing-tooltip"
  }, [_c('div', {
    staticClass: "in-cash"
  }, [_vm._v(_vm._s(_vm.numberBrazilianPattern(_vm.quotationResult.value, 2)))]), _vm._v(" "), _c('span', {
    staticClass: "forward hidden-xs hidden-sm"
  }, _vm._l((_vm.quotationResult.paymentForms), function(payments, paymentType) {
    return _c('div', {
      key: paymentType,
      staticClass: "payments"
    }, [_c('h5', [_vm._v(_vm._s(_vm.paymentTypesPreDefinition[paymentType] || paymentType))]), _vm._v(" "), _vm._l((payments), function(value, key) {
      return _c('div', {
        key: key
      }, [_vm._v("\n                                " + _vm._s(key) + " - R$ " + _vm._s(value) + "\n                            ")])
    })], 2)
  }))])]) : _vm._e(), _vm._v(" "), (_vm.showQuotationResult) ? _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-3 small-x-padding"
  }, [_c('div', [(_vm.insurerAccess) ? _c('button', {
    staticClass: "btn btn-primary no-margin open-residence-quotation hidden-xs hidden-sm",
    attrs: {
      "data-preco-id": _vm.quotationResult.priceId,
      "type": "button",
      "data-tab-id": _vm.tabId,
      "data-insurer": _vm.insurer.name
    },
    on: {
      "click": _vm.openQuotation
    }
  }, [_vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), (_vm.insurerAccess) ? _c('button', {
    staticClass: "btn btn-primary btn-block btn-xs no-margin open-residence-quotation visible-xs-block visible-sm-block",
    attrs: {
      "data-preco-id": _vm.quotationResult.priceId,
      "type": "button",
      "onclick": "location.href=javascript:void(0)",
      "data-tab-id": _vm.tabId,
      "data-insurer": _vm.insurer.name
    },
    on: {
      "click": _vm.openQuotation
    }
  }, [_vm._m(1, false, false)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-link no-padding-sides no-margin hidden-xs hidden-sm",
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationModalInsurerResult = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v("Detalhes da cotação")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link no-padding-sides no-margin visible-xs-block visible-sm-block",
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.showQuotationModalInsurerResult
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Detalhes\n                    ")])]), _vm._v(" "), _c('div', [(_vm.isPDFValid()) ? _c('a', {
    ref: 'pdf-' + _vm.quotationResult.priceId,
    staticClass: "btn btn-link no-padding no-margin hidden-xs hidden-sm",
    attrs: {
      "id": 'pdf-' + _vm.quotationResult.priceId,
      "href": _vm.quotationResult.pdf,
      "target": "_blank"
    }
  }, [_vm._m(2, false, false)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showAlertIcon) ? _c('div', {
    staticClass: "col-xs-8 col-md-8 alert-icon coluna-alert-icon icon-info"
  }, [_c('icon', {
    attrs: {
      "name": "exclamation-triangle",
      "scale": "3"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationModalAlert = true
      }
    }
  }, [_c('span', [_vm._v("DETALHES")])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTimeoutIcon) ? _c('div', {
    staticClass: "col-xs-8 col-md-8 timeout-icon coluna-timeout-icon icon-info"
  }, [_c('icon', {
    attrs: {
      "name": "clock-o",
      "scale": "3"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showQuotationTimeoutAlert = true
      }
    }
  }, [_c('span', [_vm._v("DETALHES")])])], 1) : _vm._e(), _vm._v(" "), (_vm.showQuotationResult && _vm.showQuotationModalInsurerResult) ? _c('partial-modal-result-insurer-details', {
    attrs: {
      "imagesPath": _vm.imagesPath,
      "insurer": _vm.insurer,
      "quotationResult": _vm.quotationResult
    },
    on: {
      "close": function($event) {
        _vm.showQuotationModalInsurerResult = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQuotationModalAlert) ? _c('partial-modal-alert-details', {
    attrs: {
      "imagesPath": _vm.imagesPath,
      "insurer": _vm.insurer,
      "message": _vm.errorTextMessageHover || _vm.errorTextMessage
    },
    on: {
      "close": function($event) {
        _vm.showQuotationModalAlert = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showQuotationTimeoutAlert) ? _c('partial-modal-timeout-details', {
    attrs: {
      "imagesPath": _vm.imagesPath,
      "insurer": _vm.insurer,
      "message": _vm.errorTextMessageHover || _vm.errorTextMessage
    },
    on: {
      "close": function($event) {
        _vm.showQuotationTimeoutAlert = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "error col-error"
  }, [_c('div', {
    staticClass: "coluna-error-table"
  }, [_c('div', {
    staticClass: "error-message-text",
    attrs: {
      "data-msg-hover": _vm.errorTextMessageHover
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorTextMessage)
    },
    on: {
      "mouseenter": _vm.showPopupMessage,
      "mouseleave": _vm.hidePopupMessage
    }
  })])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.haveAdditionals) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "#f8f8f8"
    }
  }, [_c('div', {
    staticClass: "grey-top-border",
    staticStyle: {
      "min-height": "23px",
      "background-color": "#f8f8f8"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAdditionals),
      expression: "!showAdditionals"
    }],
    staticClass: "btn-mostrar-ocultar",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAndHide($event)
      }
    }
  }, [_vm._v("Produtos Adicionais "), _vm._m(3, false, false)])]), _vm._v(" "), _c('div', {
    ref: "produtosAdicionais",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._l((_vm.additionalProductResult), function(additional) {
    return _c('div', {
      key: additional.produto + ' ' + additional.company.id
    }, [_c('partial-insurer-additional-product', {
      attrs: {
        "additional": additional,
        "result": _vm.result,
        "insurerAccess": _vm.insurerAccess,
        "pdfs": _vm.pdfs
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "grey-top-border"
  }, [_c('button', {
    staticClass: "btn-mostrar-ocultar",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAndHide($event)
      }
    }
  }, [_vm._v("Ocultar Produtos Adicionais "), _vm._m(4, false, false)])])], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n                            Abrir na seguradora\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n                            Abrir\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF da cotação\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-caret-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-caret-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df7fa56","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/enterprise/modules/Result/PartialInsurer.vue
// module id = 334
// module chunks = 0